import { graphql } from '@eluve/graphql-fhir';

/**
 * FHIR Patient lookup by Eluve patient identifier (the Hasura patient id the
 * profile route carries) — same seam as the Observations card.
 */
export const FHIR_PATIENT_ID_QUERY = graphql(`
  query FhirServiceRequestsPatientId($identifier: String!) {
    PatientList(identifier: $identifier, _count: 1) {
      id
    }
  }
`);

/**
 * The patient's to-dos (ENG-5368): the home-program encoding written by Care
 * Plan activation — subject AND performer = the patient, `intent: order`
 * (phase sticks are `plan`/`proposal` and never match). `draft` is
 * pre-activation and excluded; `completed` renders greyed. Reviewer-rejected
 * proposals stay `active` with a `rejected` tag and are dropped client-side
 * (see todo-list.ts). No renderer fragment exists for ServiceRequest; this
 * selection is the card's own display contract.
 */
export const PATIENT_TODOS_QUERY = graphql(`
  query FhirPatientTodos($patientRef: String!, $offset: Int) {
    ServiceRequestConnection(
      patient: $patientRef
      performer: $patientRef
      intent: "order"
      status: "active,completed"
      _count: 100
      _offset: $offset
      _sort: "-authored"
    ) {
      count
      offset
      edges {
        resource {
          resourceType
          id
          meta {
            versionId
            tag {
              system
              code
            }
          }
          status
          intent
          authoredOn
          occurrenceDateTime
          occurrencePeriod {
            end
          }
          code {
            text
          }
          requester {
            reference
            display
            resource {
              ... on Practitioner {
                resourceType
                id
                name {
                  prefix
                  given
                  family
                }
              }
            }
          }
          basedOn {
            reference
          }
        }
      }
    }
  }
`);
